(function () {
  if (window._wsLightbox) return;
  window._wsLightbox = true;

  var overlay, overlayImg, closeBtn;

  function ensureOverlay() {
    if (overlay) return;

    overlay = document.createElement('div');
    overlay.id = 'ws-lb';
    overlay.className = 'ws-lb-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Image lightbox');
    overlay.setAttribute('hidden', '');

    closeBtn = document.createElement('button');
    closeBtn.className = 'ws-lb-close';
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML =
      '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';

    overlayImg = document.createElement('img');
    overlayImg.className = 'ws-lb-img';
    overlayImg.alt = '';

    overlay.appendChild(closeBtn);
    overlay.appendChild(overlayImg);
    document.body.appendChild(overlay);
  }

  function openLb(src, alt) {
    ensureOverlay();
    overlayImg.alt = alt || '';
    overlayImg.src = src;
    overlay.removeAttribute('hidden');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeLb() {
    if (!overlay || overlay.hasAttribute('hidden')) return;
    overlay.setAttribute('hidden', '');
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    // Close — X button or backdrop
    if (overlay && !overlay.hasAttribute('hidden')) {
      if (e.target.closest('.ws-lb-close') || e.target === overlay) {
        closeLb();
        return;
      }
    }

    // Open — button wrapper
    var btn = e.target.closest('.ws-lb-trigger');
    if (btn) {
      e.preventDefault();
      var childImg = btn.querySelector('img');
      openLb(btn.dataset.src, childImg ? childImg.alt : '');
      return;
    }

    // Open — direct data-lightbox image
    var imgEl = e.target.closest('[data-lightbox]');
    if (imgEl) {
      e.preventDefault();
      openLb(imgEl.dataset.lightbox, imgEl.alt || '');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeLb();
    }
  });
})();
